var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-button',{attrs:{"icon":"file_copy","label":"Copy"},on:{"click":_vm.copySupplier}})
}
var staticRenderFns = []

export { render, staticRenderFns }